import { Fragment, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { Label } from 'lib'

import "./index.scss"
import { createPrimaryWorkFlow } from 'api/formDisplay'
import FormButton from 'components/FormButton'
import { clearSaveData } from 'redux/recursiveReducer'
import { setActiveStepOrder, setShowAccountList } from 'redux/conditionalRendering'
import { generateOtp } from 'api/otpVerification'
import { setEmail, setPhone } from 'redux/otpReducer'


const AccountList = ({ previewData, userData }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const switchProfile = useSelector(state => state.conditionalRendering?.switchProfile)
  const primaryWorkflowId = useSelector(state => state.conditionalRendering?.primaryWorkflowId)
  const dynamicConfigId = useSelector(state => state.conditionalRendering?.dynamicConfigId)

  const newUserData = {...userData,dynamicConfigId}

  const switchingProfile = (primaryWorkflowId, userId, is_verified, email, phone) => {
    if (switchProfile) {
      if (is_verified) {
        navigate(`/formSubmission/${primaryWorkflowId}/${userId}`)
      } else {
        //Send the user to the OTP verification page and generate OTP
        dispatch(setActiveStepOrder(3))
        dispatch(setShowAccountList(false))

        let otpPayload = {
          mode: "both",
          email: email,
          phoneNumber: phone
        }
        dispatch(generateOtp(otpPayload));
        dispatch(setEmail(email))
        dispatch(setPhone(phone))
        // navigate('/')
      }
    }
  }

  const handleNext = () => {
    // console.log("CREATE USER WF")
    // createPrimaryWorkFlow(newUserData, handleRedirect)
    // dispatch(clearSaveData())
  }

  if (!Object.keys(userData).length) return "Loading..."

  return (
    <>
      <div className='account_detail_container'>
        {
          
          previewData.length && previewData.map(_item => {
              return (
                <>
                     <Label label={_item?.title} />
                     <div className={_item?.class_name}>
                       {
                        _item.fields.map((item, index) => {
                          return (
                            <div className={_item?.card_type} key={index}>
                              <Label label={item.label} className={item?.label_class} />
                              <p className="preview_data_value">{userData?.source_data?.[item.name]}</p>
                            </div>
                          )
                        })
                      }
                    </div>
                  </>
              )
             
          })
        }

        {
          previewData?.map(item => {
            return  <Label label={item?.title} /> 
          })
        }
        {
          userData?.source_data?.applicants?.map((item, index) => {
            const { is_verified, _id: userId, email, mobile_number: phone } = item
            return (
              <Fragment key={index}>
                <div
                  className={is_verified ? "verified_container" : "pending_container"}
                  onClick={() => switchingProfile(
                    userData.hasOwnProperty("_id") ? userData?._id : primaryWorkflowId,
                    userId, is_verified, email, phone
                  )}
                >
                  {is_verified ? (<p className='status'>Verified</p>) : (<p className='status'>Pending</p>)}
                  <p className="image"></p>
                  <div className='user_details'>
                    {
                     
                      previewData.map(item => {
                        return item?.fields?.map((_item, _index) => {
                          const { name, class_name } = _item;
                          return (
                                <Label label={item?.[name]} className={class_name} key={_index} />
                              )
                        })
                      })
                    }
                  </div>
                </div>
              </Fragment>
            )

          })
        }

        {
          !switchProfile &&
          <FormButton
            formButtons={previewData?.user_actions}
            handleNext={handleNext}
          />
        }

      </div>
    </>

  )

}

export default AccountList